import React from 'react';
import { IChain } from '@sc1/common/utils/constants';
import { ButtonLink } from '../../core';
import { useSearchParam } from '@sc1/common/hooks';

export const ChainTab = ({ chain }: { chain: IChain }): JSX.Element => {
  const { get, editSearchParam } = useSearchParam();
  const tab = (get('chain') as IChain) || 'all chains';
  const search = editSearchParam('chain', chain, 'all chains');
  return (
    <ButtonLink
      mr={3}
      variant={chain == tab ? 'buttons.tab' : 'buttons.tabFaded'}
      sx={{ textTransform: 'capitalize' }}
      to={(location) => ({
        ...location,
        search,
      })}
    >
      {chain}
    </ButtonLink>
  );
};
